import debugLogScriptName from '@/debug-log-script-name'
import _ from 'lodash'

$(function() {
  const $tableToolbar = $('.table-toolbar')
  debugLogScriptName($tableToolbar, 'table-toolbar.js') // DEBUG
  $tableToolbar.each(function() {
    var $toolbar = $(this),
      $form = $toolbar.find('form'),
      $search = $form.find('[type="search"]'),
      $checkboxes = $form.find('[type="checkbox"]'),
      $table = $($toolbar.find('.table-toolbar__filters').attr('data-target')),
      isDataTable = $.fn.dataTable.isDataTable($table)
    // console.log($table, $search, isDataTable, $table.data('ajax-url'));

    if ($table.length && $search.length && isDataTable) {
      var dataTable = $table.DataTable() // Retrieve object instance

      if ($table.data('ajax-url')) {
        $search.on('change', function(e) {
          e.stopPropagation()
          dataTable.search($(this).val()).draw() // Global datatable search
        })
      } else {
        $search
          .on('change', function(e) {
            e.stopPropagation()
          })
          .on(
            'keyup',
            _.debounce(function(e) {
              dataTable.search($(this).val()).draw() // Global datatable search
            }, 300),
          )

        $checkboxes.on('change', function(e) {
          var checkboxes = $checkboxes
            .map(function() {
              return {
                name: this.name,
                column: this.getAttribute('data-column'),
                checked: this.checked,
              }
            })
            .get()

          $.each(checkboxes, function(i, val) {
            if (val.checked) {
              dataTable.column(val.column).search(val.name) // Column datatable search
            } else {
              dataTable.column(val.column).search('')
            }
          })

          dataTable.draw()
        })
      }
    }
  })
})
